import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import { handleSessionExpired } from './auth'
// create an axios instance
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
const service = axios.create({
  baseURL: '/apiip', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
})
// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['userToken'] = store.getters.token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    let data = response.data?.message || response?.data[0].message;

    if ((response?.data?.code ? response?.data?.code : response?.data[0]?.code) != 200) {
      let message = "";
      switch (response?.data?.code ? response?.data?.code : response?.data[0]?.code) {
        case 401:
          localStorage.removeItem("userToken");
          router.push("/login");
          message = data;
          break;
        case 400:
          message = data;
          break;
        case 403:
          message = data;
          break;
        case 404:
          message = data;
          break;
        case 500:
          message = data;
          break;
        default:
          message = data;
          break;
      }
      Message({
        type: "error",
        message,
      });
      return Promise.resolve(response.data)
    }
    return Promise.resolve(response.data)
  },
  error => {
    // token过期兜底:与request.js同款处理(原401分支引用未导入的router且清错token位置,系死代码已随本次统一)
    const respText = JSON.stringify(error.response?.data || '')
    if (error.response?.status === 401 || respText.indexOf('Signature has expired') !== -1) {
      handleSessionExpired()
      return Promise.reject(error.response.data)
    }
    Message({
      dangerouslyUseHTMLString: true,
      message: error.response.data.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error.response.data)
  }
)

export default service
